import React from "react"
import styled from "styled-components"
import media from "styles/media"
import colors from "styles/colors"
import text from "styles/text"

import { ReactComponent as CollapsedArrowSVG } from "images/collapsedArrow.svg"
import { ReactComponent as ArrowLinkSVG } from "images/linkArrow.svg"

const StyledLink = ({ children, bottom, href, color }) => {
  return (
    <Link href={href} bottom={bottom} color={color}>
      {children}
      <ArrowDiv>
        <CollapsedArrow color={color} />
        <ArrowLink color={color} />
      </ArrowDiv>
    </Link>
  )
}

const ArrowLink = styled(ArrowLinkSVG)`
  position: absolute;
  opacity: 0;
  path {
    fill: ${props => (props.color ? props.color : colors.primaryOrange)};
  }
`
const CollapsedArrow = styled(CollapsedArrowSVG)`
  color: ${props => (props.color ? props.color : colors.primaryOrange)};

  path {
    fill: ${props => (props.color ? props.color : colors.primaryOrange)};
  }
`
const ArrowDiv = styled.div`
  position: relative;
  display: grid;
  place-items: center;
`
const Link = styled.a`
  ${text.bodyMdBold};
  position: relative;
  display: flex;
  flex-direction: row;
  justify-self: end;
  margin-top: ${props => (props.bottom ? "auto" : "unset")};
  color: ${props => (props.color ? props.color : colors.primaryOrange)};
  gap: 0.347vw;

  ${media.fullWidth} {
    gap: 5px;
  }

  ${media.hover} {
    &:hover {
      ${CollapsedArrow} {
        position: relative;
        left: 0.139vw;
        transition-duration: 1000ms;
        transition-delay: 500ms;

        ${media.fullWidth} {
          left: 2px;
        }
      }
      ${ArrowLink} {
        opacity: 1;
        transition-duration: 750ms;
      }
    }
  }
`
export default StyledLink
